const canonicalSlugs: Record<string, string> = {
  'blog/petar-nikolov-bnt-imotni-izmami-bg': 'blog/petar-nikolov-pred-bnt-imotni-izmami',
  'blog/petar-nikolov-bnt-property-fraud-en': 'blog/petar-nikolov-bnt-property-fraud',
};

const legacySlugs = Object.fromEntries(
  Object.entries(canonicalSlugs).map(([legacy, canonical]) => [canonical, legacy])
);

function withBlogPrefix(slug: string) {
  return slug.startsWith('blog/') ? slug : `blog/${slug}`;
}

export function canonicalArticleSlug(slug: string) {
  const prefixed = withBlogPrefix(slug);
  return canonicalSlugs[prefixed] ?? prefixed;
}

export function articlePath(slug: string) {
  return `/${canonicalArticleSlug(slug)}`;
}

export function articleSlugCandidates(slug: string) {
  const prefixed = withBlogPrefix(slug);
  const canonical = canonicalArticleSlug(prefixed);
  const candidates = [canonical, legacySlugs[canonical], prefixed, slug].filter((candidate): candidate is string => Boolean(candidate));
  return candidates.filter((candidate, index) => candidates.indexOf(candidate) === index);
}
